import { MailDto } from "@/data/dtos/mail.dto";
import { apiClient } from "./base.service";

const mailerService = {
  sendMail: async (payload: MailDto) =>
    await apiClient.post("/notify", payload),
};

export default mailerService;
